import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { useAuth } from "../../../../hooks";
import { updateServer } from "../../../../api";
import "./ServerForm.scss";

export function UpdateVisoresForm({ onClose, onReload, server }) {
  const { accessToken } = useAuth();
  // Inicializamos con el valor actual del servidor o 4 por defecto
  const [visores, setVisores] = useState(server.visores ?? 4);
  const [loading, setLoading] = useState(false);

  const handleIncrement = () => setVisores((v) => v + 1);
  const handleDecrement = () => setVisores((v) => Math.max(0, v - 1));

  const onSubmit = async () => {
    setLoading(true);
    try {
      // Usamos la nueva función updateServer creada en el Paso 1
      await updateServer(accessToken, server._id, { visores });
      onReload(); // Recargar la lista
      onClose(); // Cerrar modal
    } catch (error) {
      console.error("Error actualizando visores:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update-visores-form" style={{ padding: "10px 0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        <Button
          icon
          circular
          size="large"
          onClick={handleDecrement}
          disabled={visores <= 0}
        >
          <Icon name="minus" />
        </Button>

        <span
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            minWidth: "50px",
            textAlign: "center",
          }}
        >
          {visores}
        </span>

        <Button icon circular size="large" onClick={handleIncrement}>
          <Icon name="plus" />
        </Button>
      </div>

      <Button primary fluid loading={loading} onClick={onSubmit}>
        Guardar cambios
      </Button>
    </div>
  );
}
